import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import NewsItem from "../components/news-item";
import { NavLink } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";

export default function News() {
  const [page, setPage] = useState({});
  const [posts, setPosts] = useState([]);
  const [pageMedia, setPageMedia] = useState([]);
  const [loading, setLoading] = useState({});
  let { getMetaSnippet } = useUtilities();

  useEffect(() => {
    setLoading(true);
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "news-and-media"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};

        setPage(pageResponse);

        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(CONTENT_ROUTES.CATEGORIES("?slug=featured-in"))
      .then((res) => {
        const categoryId = res.data?.[0]?.id;
        const excludeParam = categoryId
          ? `&categories_exclude=${categoryId}`
          : "";
        return axios.get(
          CONTENT_ROUTES.POSTS(
            `?_embed&orderby=date&order=desc&per_page=100${excludeParam}`,
          ),
        );
      })
      .then((res) => {
        if (res) setPosts(res.data);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>{`News and media - Nant Power`}</title>
        <meta
          name="description"
          content={`Stay up-to-date with the latest news, trends, and expert insights in infrastructure investments. Explore expert analysis, updates, and in-depth articles on industry developments.`}
        />
      </Helmet>

      <Header />
      <main>
        <section className="bg-white md:py-16 py-8">
          <div className="container mx-auto md:px-0 px-8">
            <div className="text-base leading-7 ">
              <div className=" flex justify-between items-center gap-x-4 mb-2">
                <h1 className="text-4xl font-medium ">
                  {page?.title?.rendered}
                </h1>

                <NavLink
                  to={WEB_ROUTES.FEATURED_IN}
                  className="text-[#58b947] md:text-2xl font-normal"
                >
                  <span>Featured in → </span>
                </NavLink>
              </div>
              <div
                className="text-[#58b947] text-2xl font-medium"
                dangerouslySetInnerHTML={{
                  __html: page?.content?.rendered,
                }}
              />
            </div>
          </div>
        </section>

        <section className="bg-white md:pb-16 pb-8">
          <div className="container mx-auto md:px-0 px-8">
            <div className="mx-auto md:flex gap-x-8 md:space-y-0 space-y-8">
              <div className="md:w-1/2 w-full">
                {posts?.slice(0, 1)?.map((article, i) => (
                  <Fragment key={i}>
                    <NewsItem article={article} size={"large"} />
                  </Fragment>
                ))}
              </div>

              <div className="md:w-1/2 w-full md:flex gap-x-8 md:space-y-0 space-y-8">
                {posts?.slice(1, 3)?.map((article, i) => (
                  <Fragment key={i}>
                    <NewsItem article={article} size={"normal"} />
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white pb-16">
          <div className="container mx-auto md:px-0 px-8">
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 md:gap-y-20 gap-y-10 lg:mx-0 lg:max-w-none lg:grid-cols-4">
              {posts?.slice(3)?.map((article, i) => (
                <Fragment key={i}>
                  <NewsItem article={article} size={"normal"} />
                </Fragment>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
